

































  import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
  import moment from 'moment';
  import BookingDetail from "@/views/Bookings/BookingDetail.vue";

@Component({
  components: {
    BookingDetail
  },
})
export default class ReservationTableCard extends Vue {

  @Prop() items!:any
  @Prop() totalItems!:any
  @Prop() loading!:any

  public itemPerPageOptions:any ={'items-per-page-options': [5, 10, 20]}
  public options = {
    page: 1,
    itemsPerPage: 5
  }
  public expanded:any = []
  public singleExpand:boolean =  true
  public dialog = false
  public bookingId:any = null
  public headers:any=[
    {text: 'Id', value: 'id'},
    /*{text: 'Billing Status', value: 'billing_status'},
    {text: 'Booking Mode', value: 'booking_mode',},*/
    {text: 'BillStatus BookMode', value: 'bs_bm'},
   // {text: 'Dist Km', value: 'distance',},
    {text: 'Dist Km/Cost €', value: 'distance_cost',},

    {text: 'Status', value: 'status',},

    { text: '', value: 'data-table-expand' },
  ]

    @Watch('options', {deep: true})
    public emitOption(options:any){
      this.$emit('selectedReservationOptions', options )
    }

  public showReservationDetail(item:any) {
    this.dialog = false;
    this.bookingId = item.id
    //this.$router.push({name: 'reservation', params: {id: item.id}})
//   this.url = this.$router.resolve({name: 'reservation', params: {id: item.id}})
// console.log(JSON.stringify(this.url.href))
    this.$nextTick(() => {
      this.dialog = true;
    })
  }
  public bookingDuration(start:any, end:any) {
    let x = moment(start)
    let y = moment(end)
    let duration = moment.duration(x.diff(y)).humanize()
    return duration
  }

}
